












import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import XLSX from 'xlsx';

export class ExcelData {
  header: any;
  results: any;
}

@Component({
  name: "UploadExcel"
})
export default class extends mixins(CommonMixin) {
  @Prop({ type: Function }) readonly beforeUpload!: Function;
  @Prop({ type: Function }) readonly onSuccess!: Function;

  loading = false;
  excelData: ExcelData = {
    header: null,
    results: null
  }

  generateData({ header, results }) {
    this.excelData.header = header
    this.excelData.results = results
    this.onSuccess && this.onSuccess(this.excelData)
  }
  handleUpload() {
    (this.$refs['excel-upload-input'] as any).click();
  }
  handleClick(e) {
    const files = e.target.files
    const rawFile = files[0] // only use files[0]
    if (!rawFile) return
    this.upload(rawFile)
  }
  upload(rawFile) {
    (this.$refs['excel-upload-input'] as any).value = null // fix can't select the same excel
    if (!this.beforeUpload) {
      this.readerData(rawFile)
      return
    }
    const before = this.beforeUpload(rawFile)
    if (before) {
      this.readerData(rawFile)
    }
  }
  readerData(rawFile) {
    this.loading = true
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = e => {
        const data = e?.target?.result
        const workbook = XLSX.read(data, { type: 'array' })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const header = this.getHeaderRow(worksheet)
        const results = XLSX.utils.sheet_to_json(worksheet)
        this.generateData({ header, results })
        this.loading = false
        resolve()
      }
      reader.readAsArrayBuffer(rawFile)
    })
  }
  getHeaderRow(sheet) {
    const headers: any = []
    const range = XLSX.utils.decode_range(sheet['!ref'])
    let C
    const R = range.s.r
    /* start in the first row */
    for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
      const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
      /* find the cell in the first row */
      let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
      if (cell && cell.t) {
          hdr = XLSX.utils.format_cell(cell)
          headers.push(hdr)
      }
    }
    return headers
  }
  isExcel(file) {
    return /\.(xlsx|xls|csv)$/.test(file.name)
  }
}
